// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
This computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), 
is the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.
*/
.autoCompleteLazyLoadctrl.base {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.autoCompleteLazyLoadctrl .optionLabel {
  height: 35px;
  margin: 0px;
}

.autoCompleteLazyLoadctrl .autocompleteLabel {
  margin: 0px;
  padding: 0px;
  position: relative;
  transform: inherit;
  font-family: var(--label-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--label-FontColour);
  letter-spacing: var(--font-letter-space);
}

.autoCompleteLazyLoadctrl .autoCompleteInput {
  background-color: var(--gridbgcolor);
  border: 1px solid var(--controlborder-colour);
  border-radius: 4px;
  box-sizing: border-box;
  height: 33px;
  padding: 15px 10px;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  text-align: var(--textahrlignment);
  letter-spacing: var(--font-letter-space);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.autoCompleteLazyLoadctrl .inputAutocompleteLazyLoad,
.autoCompleteLazyLoadctrl .inputAutocompleteLazyLoad:focus-visible {
  width: 100%;
  border-radius: 4px;
  border: none;
  outline: none;
  padding: 0px 15px;
}

.userSetupPage .autoCompleteLazyLoadctrl .inputAutocompleteLazyLoad,
.userSetupPage
  .autoCompleteLazyLoadctrl
  .inputAutocompleteLazyLoad:focus-visible {
  padding: 0px 10px;
}

.autoCompleteLazyLoad .optionLabel {
  height: 35px;
  font-family: var(--default-FontName);
  font-size: var(--default-FontSize);
  font-weight: var(--default-FontWeight);
  color: var(--default-FontColour);
  text-align: var(--textahrlignment);
  letter-spacing: var(--font-letter-space);
  white-space: nowrap;
  /*margin-block-start: 0px; */
  /* margin-block-end: 0px; */
  padding: 10px;
  align-items: center;
  cursor: default;
}
.autoCompleteLazyLoad .optionLabel.disableLabel {
  color: var(--inputControlDisabledTextColor);
}
.autoCompleteLazyLoad
  .optionLabel:hover:not(
    .autoCompleteLazyLoad .optionLabel.disableLabel,
    .autoCompleteLazyLoadPopper.messagePopper .optionLabel
  ) {
  background-color: rgba(0, 0, 0, 0.04);
}
.autoCompleteLazyLoadPopper.messagePopper .optionLabel {
  padding: 7px;
}
.autoCompleteLazyLoad .optionLabel.selected {
  background-color: rgba(0, 0, 0, 0.08);
}

.autoCompleteLazyLoad .optionLabel .OptionIcon {
  padding-right: 2rem;
  height: 24px;
  width: 24px;
}

.autoCompleteLazyLoadPopper {
  z-index: 2000;
  border-radius: 4px;
  background-color: var(--gridbgcolor);
  box-shadow: 0px 2px rgb(184, 179, 179);
  border: 1px solid rgb(184 179 179);
  /* padding: 5px; */
}
.autoCompleteLazyLoadPopper.messagePopper {
  margin-top: 5px !important;
  border-radius: 5px;
  background: var(--tooltipFontColor);
  box-shadow: none;
}
.autoCompleteLazyLoadctrl .autoCompleteLazyLoadinputDiv {
  border: 1px solid;
  display: flex;
  flex-direction: row;
  background-color: var(--gridbgcolor);
  border: 1px solid var(--controlborder-colour);
  box-sizing: border-box;
  border-radius: 4px;
  align-items: center;
}

.autoCompleteLazyLoadctrl .autoCompleteLazyLoadinputDiv.disabled,
.autoCompleteLazyLoadctrl
  .autoCompleteLazyLoadinputDiv.disabled
  .autoCompleteInput,
.autoCompleteLazyLoadctrl
  .autoCompleteLazyLoadinputDiv.disabled
  .autoCompleteInput_form {
  background-color: var(--inputControlDisabledBgColor) !important;
  pointer-events: none;
  color: var(--inputControlDisabledTextColor);
}

.formviewer .autoCompleteLazyLoadctrl {
  display: flex;
  width: 100%;
}

.autoCompleteLazyLoadctrl .Formvwer-Label {
  margin-top: 7px;
  /* display: block; */
  /* white-space: nowrap; */
  text-overflow: ellipsis;
  overflow-wrap: anywhere;
  justify-content: var(--textahrlignment);
}

.Formviwer .autoCompleteLazyLoadctrl .autoCompleteLazyLoadinputDiv {
  border: none;
}

.autoCompleteLazyLoadPopper .infiniteScrollDiv {
  min-height: 35px;
  max-height: 250px;
  /* Height of lazyLoad data */
  overflow: auto;
  /* padding: 5px; */
  display: grid;
}

.autoCompleteLazyLoadctrl .autoCompleteLazyLoadinputDiv {
  display: flex;
}

/*For Row and col wise controls*/
.autoCompleteLazyLoadctrl .rowWiseControl {
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 9px;
}

.autoCompleteLazyLoadctrl .colWiseControl {
  display: flex;
  flex-direction: column;
  gap: 9px;
}

.autoCompleteLazyLoadctrl .controlLabelDiv {
  font-family: var(--default-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--label-FontColour);
  line-height: 1;
  /* given as per MuiFormLabel-root*/
  display: flex;
  flex-direction: row;
  align-items: center;
}

.autoCompleteLazyLoadctrl .rowWiseControl .controlLabelDiv {
  width: 200px;
}

.autoCompleteLazyLoadctrl .iconPadding {
  height: 16px;
  width: 16px;
}

.autoCompleteLazyLoadctrl svg.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium {
  margin-right: 5px;
  cursor: pointer;
}

.autoCompleteLazyLoadctrl .fieldAlert {
  color: var(--required-color);
  font-family: var(--default-FontName);
  font-size: var(--fieldAlertFontSize);
  font-weight: var(--default-FontWeight);
  line-height: 1.66;
  letter-spacing: 0.03333em;
}

.autoCompleteLazyLoadctrl .outlineError .autoCompleteLazyLoadinputDiv {
  border: 1px solid var(--required-color) !important;
  border-radius: 4px;
}

.autoCompleteLazyLoadctrl ::placeholder {
  font-family: var(--default-FontName);
  font-size: var(--label-FontSize);
  font-weight: var(--label-FontWeight);
  color: var(--placeHolderColor);
  opacity: 1;
}

.userDataSection .roleSetup .autoCompleteLazyLoadctrl .autoCompleteInput,
.userDataSection
  .roleSetup
  .autoCompleteLazyLoadctrl
  .autoCompleteLazyLoadinputDiv {
  background-color: white;
}

.userDataSection
  .roleSetup
  .autoCompleteLazyLoadctrl
  .autoCompleteLazyLoadinputDiv {
  border: 1px solid var(--inputControlBorderColor);
}

.userSetupPage
  .userCodeSection
  .userDataSection
  .roleSetup
  .autoCompleteLazyLoadinputDiv.disabled,
.userSetupPage
  .userCodeSection
  .userDataSection
  .roleSetup
  .autoCompleteLazyLoadinputDiv.disabled
  .autoCompleteInput {
  background-color: var(--disableBgColor);
}
`, "",{"version":3,"sources":["webpack://./src/views/components/base/autoComplete/AutoComplete.css"],"names":[],"mappings":"AAAA;;;CAGC;AACD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;EAChC,kCAAkC;EAClC,wCAAwC;EACxC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA;;;;EAIE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,kCAAkC;EAClC,sCAAsC;EACtC,gCAAgC;EAChC,kCAAkC;EAClC,wCAAwC;EACxC,mBAAmB;EACnB,4BAA4B;EAC5B,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,2CAA2C;AAC7C;AACA;;;;;EAKE,qCAAqC;AACvC;AACA;EACE,YAAY;AACd;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oCAAoC;EACpC,sCAAsC;EACtC,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,6CAA6C;EAC7C,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,+DAA+D;EAC/D,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,uBAAuB;EACvB,uBAAuB;EACvB,uCAAuC;AACzC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,oCAAoC;EACpC,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,8BAA8B;EAC9B,UAAU;AACZ;;AAEA;;;;;EAKE,uBAAuB;AACzB;;AAEA;;;;EAIE,gDAAgD;AAClD;;AAEA;;;;;;;;;;;EAWE,uCAAuC;AACzC","sourcesContent":["/*\nThis computer program, as defined in the Copyright, Designs and Patents Act 1998 and the Software Directive (2009/24/EC), \nis the copyright of Logic Valley Ltd, a wholly owned subsidiary of Marston (Holdings) Ltd. All rights are reserved.\n*/\n.autoCompleteLazyLoadctrl.base {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n\n.autoCompleteLazyLoadctrl .optionLabel {\n  height: 35px;\n  margin: 0px;\n}\n\n.autoCompleteLazyLoadctrl .autocompleteLabel {\n  margin: 0px;\n  padding: 0px;\n  position: relative;\n  transform: inherit;\n  font-family: var(--label-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--label-FontColour);\n  letter-spacing: var(--font-letter-space);\n}\n\n.autoCompleteLazyLoadctrl .autoCompleteInput {\n  background-color: var(--gridbgcolor);\n  border: 1px solid var(--controlborder-colour);\n  border-radius: 4px;\n  box-sizing: border-box;\n  height: 33px;\n  padding: 15px 10px;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  text-align: var(--textahrlignment);\n  letter-spacing: var(--font-letter-space);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.autoCompleteLazyLoadctrl .inputAutocompleteLazyLoad,\n.autoCompleteLazyLoadctrl .inputAutocompleteLazyLoad:focus-visible {\n  width: 100%;\n  border-radius: 4px;\n  border: none;\n  outline: none;\n  padding: 0px 15px;\n}\n\n.userSetupPage .autoCompleteLazyLoadctrl .inputAutocompleteLazyLoad,\n.userSetupPage\n  .autoCompleteLazyLoadctrl\n  .inputAutocompleteLazyLoad:focus-visible {\n  padding: 0px 10px;\n}\n\n.autoCompleteLazyLoad .optionLabel {\n  height: 35px;\n  font-family: var(--default-FontName);\n  font-size: var(--default-FontSize);\n  font-weight: var(--default-FontWeight);\n  color: var(--default-FontColour);\n  text-align: var(--textahrlignment);\n  letter-spacing: var(--font-letter-space);\n  white-space: nowrap;\n  /*margin-block-start: 0px; */\n  /* margin-block-end: 0px; */\n  padding: 10px;\n  align-items: center;\n  cursor: default;\n}\n.autoCompleteLazyLoad .optionLabel.disableLabel {\n  color: var(--inputControlDisabledTextColor);\n}\n.autoCompleteLazyLoad\n  .optionLabel:hover:not(\n    .autoCompleteLazyLoad .optionLabel.disableLabel,\n    .autoCompleteLazyLoadPopper.messagePopper .optionLabel\n  ) {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n.autoCompleteLazyLoadPopper.messagePopper .optionLabel {\n  padding: 7px;\n}\n.autoCompleteLazyLoad .optionLabel.selected {\n  background-color: rgba(0, 0, 0, 0.08);\n}\n\n.autoCompleteLazyLoad .optionLabel .OptionIcon {\n  padding-right: 2rem;\n  height: 24px;\n  width: 24px;\n}\n\n.autoCompleteLazyLoadPopper {\n  z-index: 2000;\n  border-radius: 4px;\n  background-color: var(--gridbgcolor);\n  box-shadow: 0px 2px rgb(184, 179, 179);\n  border: 1px solid rgb(184 179 179);\n  /* padding: 5px; */\n}\n.autoCompleteLazyLoadPopper.messagePopper {\n  margin-top: 5px !important;\n  border-radius: 5px;\n  background: var(--tooltipFontColor);\n  box-shadow: none;\n}\n.autoCompleteLazyLoadctrl .autoCompleteLazyLoadinputDiv {\n  border: 1px solid;\n  display: flex;\n  flex-direction: row;\n  background-color: var(--gridbgcolor);\n  border: 1px solid var(--controlborder-colour);\n  box-sizing: border-box;\n  border-radius: 4px;\n  align-items: center;\n}\n\n.autoCompleteLazyLoadctrl .autoCompleteLazyLoadinputDiv.disabled,\n.autoCompleteLazyLoadctrl\n  .autoCompleteLazyLoadinputDiv.disabled\n  .autoCompleteInput,\n.autoCompleteLazyLoadctrl\n  .autoCompleteLazyLoadinputDiv.disabled\n  .autoCompleteInput_form {\n  background-color: var(--inputControlDisabledBgColor) !important;\n  pointer-events: none;\n  color: var(--inputControlDisabledTextColor);\n}\n\n.formviewer .autoCompleteLazyLoadctrl {\n  display: flex;\n  width: 100%;\n}\n\n.autoCompleteLazyLoadctrl .Formvwer-Label {\n  margin-top: 7px;\n  /* display: block; */\n  /* white-space: nowrap; */\n  text-overflow: ellipsis;\n  overflow-wrap: anywhere;\n  justify-content: var(--textahrlignment);\n}\n\n.Formviwer .autoCompleteLazyLoadctrl .autoCompleteLazyLoadinputDiv {\n  border: none;\n}\n\n.autoCompleteLazyLoadPopper .infiniteScrollDiv {\n  min-height: 35px;\n  max-height: 250px;\n  /* Height of lazyLoad data */\n  overflow: auto;\n  /* padding: 5px; */\n  display: grid;\n}\n\n.autoCompleteLazyLoadctrl .autoCompleteLazyLoadinputDiv {\n  display: flex;\n}\n\n/*For Row and col wise controls*/\n.autoCompleteLazyLoadctrl .rowWiseControl {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  gap: 9px;\n}\n\n.autoCompleteLazyLoadctrl .colWiseControl {\n  display: flex;\n  flex-direction: column;\n  gap: 9px;\n}\n\n.autoCompleteLazyLoadctrl .controlLabelDiv {\n  font-family: var(--default-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--label-FontColour);\n  line-height: 1;\n  /* given as per MuiFormLabel-root*/\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.autoCompleteLazyLoadctrl .rowWiseControl .controlLabelDiv {\n  width: 200px;\n}\n\n.autoCompleteLazyLoadctrl .iconPadding {\n  height: 16px;\n  width: 16px;\n}\n\n.autoCompleteLazyLoadctrl svg.MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium {\n  margin-right: 5px;\n  cursor: pointer;\n}\n\n.autoCompleteLazyLoadctrl .fieldAlert {\n  color: var(--required-color);\n  font-family: var(--default-FontName);\n  font-size: var(--fieldAlertFontSize);\n  font-weight: var(--default-FontWeight);\n  line-height: 1.66;\n  letter-spacing: 0.03333em;\n}\n\n.autoCompleteLazyLoadctrl .outlineError .autoCompleteLazyLoadinputDiv {\n  border: 1px solid var(--required-color) !important;\n  border-radius: 4px;\n}\n\n.autoCompleteLazyLoadctrl ::placeholder {\n  font-family: var(--default-FontName);\n  font-size: var(--label-FontSize);\n  font-weight: var(--label-FontWeight);\n  color: var(--placeHolderColor);\n  opacity: 1;\n}\n\n.userDataSection .roleSetup .autoCompleteLazyLoadctrl .autoCompleteInput,\n.userDataSection\n  .roleSetup\n  .autoCompleteLazyLoadctrl\n  .autoCompleteLazyLoadinputDiv {\n  background-color: white;\n}\n\n.userDataSection\n  .roleSetup\n  .autoCompleteLazyLoadctrl\n  .autoCompleteLazyLoadinputDiv {\n  border: 1px solid var(--inputControlBorderColor);\n}\n\n.userSetupPage\n  .userCodeSection\n  .userDataSection\n  .roleSetup\n  .autoCompleteLazyLoadinputDiv.disabled,\n.userSetupPage\n  .userCodeSection\n  .userDataSection\n  .roleSetup\n  .autoCompleteLazyLoadinputDiv.disabled\n  .autoCompleteInput {\n  background-color: var(--disableBgColor);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
